import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getProperty } from "../admin/properties.js";
import PropertyInventoryPage from "./propertyInventory.jsx";
import NoPage from "./noPage.jsx";

function PublicPropertyPage() {
  const { propertySlug } = useParams();
  const propertyId = decodeURIComponent(propertySlug || "");
  const [loading, setLoading] = useState(true);
  const [propertyExists, setPropertyExists] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function checkProperty() {
      try {
        const property = await getProperty(propertyId);

        if (isMounted) {
          setPropertyExists(Boolean(property));
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    if (!propertyId) {
      setLoading(false);
      setPropertyExists(false);
      return undefined;
    }

    checkProperty();

    return () => {
      isMounted = false;
    };
  }, [propertyId]);

  if (!propertyId) {
    return <Navigate replace to="/" />;
  }

  if (loading) {
    return null;
  }

  if (!propertyExists) {
    return <NoPage />;
  }

  return <PropertyInventoryPage propertyId={propertyId} />;
}

export default PublicPropertyPage;
